import { CanvasContext } from "client/contexts/ResizeEditor/Canvas";
import { flipImage } from "client/utils/imageEdit/flipImage";
import { sleep } from "client/utils/sleep";
import { useContext, useState } from "react";
import { flipToggleHorizontal, flipToggleVertical } from "store/features/flipRotate/actions";
import { flipRotateSelector } from "store/features/flipRotate/selectors/flipRotateSelector";
import { useLoadFromParentImage } from "store/features/resizeEditor/hooks/useLoadFromParentImage";
import { useAppDispatch, useAppSelector } from "store/store";

export type FlipState = "horizontal" | "vertical" | "";

export const useFlipSettings = () => {
    const {
        image,
        flip: { horizontal, vertical },
    } = useAppSelector(flipRotateSelector);
    const dispatch = useAppDispatch();
    const { flipRef, initialImageRef, parentImageRef: canvasRef, imageLoaded } = useContext(CanvasContext);
    const { isLoaded } = useLoadFromParentImage(flipRef);
    const [flipState, setFlipState] = useState<FlipState>("");

    const handleHorizontalToggle = async () => {
        if (!isLoaded || !imageLoaded || flipState !== "") return;
        setFlipState("horizontal");
        await sleep();
        await flip(!horizontal, vertical);
        setFlipState("");
        dispatch(flipToggleHorizontal());
    };

    const handleVerticalToggle = async () => {
        if (!isLoaded || !imageLoaded || flipState !== "") return;
        setFlipState("vertical");
        await sleep();
        await flip(horizontal, !vertical);
        setFlipState("");
        dispatch(flipToggleVertical());
    };

    const flip = async (flipH: boolean, flipV: boolean) => {
        if (!flipRef?.current || !canvasRef?.current || !initialImageRef?.current) return;
        await flipImage(
            flipH,
            flipV,
            flipRef.current,
            initialImageRef?.current?.getAttribute("src") || image.src,
            image.initialWidth,
            image.initialHeight,
        );
    };

    return {
        handleHorizontalToggle,
        handleVerticalToggle,
        flipState,
    };
};
